import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const joinWaitlist = async ({ name, email, company }) => {
  const { data } = await apiClient.post("/waitlist", { name, email, company });
  return data;
};

export const getWaitlistCount = async () => {
  const { data } = await apiClient.get("/waitlist/count");
  return data.count;
};
